export default {
  home: "Home",
  product: "Products",
  apply: "Application",
  zlykkx: 'Quality & Reliability',
  support: "Resource",
  onlineClass: "Online Class",
  tecArticles: "Technical Article",
  aboutUs: "About us",
  introduce: 'Company Profile',
  news: "News",
  contact: 'Contact Us',
  xsydls: "Sales & Agents",
  joinUs: "Join Us",
  LearnMore: "Learn more",
  ProductCenter: "Product Center",
  IndustryApplication: "Industry Application",
  CompanyProfile: "Company Profile",
  InvestmentPartners: "Investment Partners",
  ContactUs: "Contact Us",
  NewsCenter: "News Center",
  footer1: "Focus on High-Performance Analog Signal Chain Chip Design",
  BeijingOffice: "Beijing Office",
  BeijingAddress: "9th Floor, Tower A, Xueqing Jiachuang Building,Courtyard 10, Xueqing Road, Haidian District, Beijing",
  ChengduOffice: "Chengdu Office",
  ChengduAddress: "10th Floor, Unit 1, Building 1,Goodix Technology Mansion, No.10 Jitai Road,High-tech Zone, Chengdu",
  SalesInquiries: "Sales Inquiries",
  sales1: "(North China / Northwest / Southwest China)",
  sales2: "(East China / Central China)",
  sales3: "(South China)",
  sales4: "(Nationwide)",
  Email: "Email",
  Sales: "Sales",
  Recruitment: "Recruitment",
  service: "Service",
  FollowUs: "Follow Us",
  NewProducts: "New Products",
  ProductSelectionTable: "Product Selection Table",
  Filters: "Filters",
  SearchPart: "Search Part Number",
  Reset: "Reset",
  ProductInformation: "Product Information",
  Description: "Description",
  ProductVideo: "Product Video",
  Features: "Features",
  Applications: "Applications",
  OrderingGuide: "Ordering Guide",
  SalesInquiry: "Sales Inquiry",
  address: "Address",
  phone: "Phone",
  wechat: "WeChat",
  NewProductReleases: "New Product Releases",
  productDetail: "Product Details",
  globalSeo: {
    title: 'Cimo | High-performance Data Converter IC',
    description: 'High-performance Data Converter IC',
    keywords: 'High-performance Data Converter IC'
  },
  SocialRecruitment:"Social Recruitment",
  CampusRecruitment:"Campus Recruitment",
  ViewJobs:"View Jobs",
  RecruitmentContents:"At Cimo Microelectronics, our teams are led by well-recognized industry experts. We uphold a work ethos of focus, efficiency and result-orientation, building a platform where every employee can thrive and grow. We regard outstanding talents as our most valuable asset. If you are innovative and ready to embrace challenges, join Cimo and grow alongside the company to achieve mutual success.",
  aboutustest11:"High-efficiency Team",
  aboutustest12:"Led by Industry Experts",
  aboutustest13:"Expert-led efficient team",
  aboutustest14:"Flat management structure",
  aboutustest21:"Industry-leading R&D",
  aboutustest22:"Achievements",
  aboutustest23:"Self-owned IP",
  aboutustest24:"World-class Original Technologies",
  aboutustest31:"Innovation-focused",
  aboutustest32:"Learning",
  aboutustest33:"Frontier Tech Sharing Custom",
  aboutustest34:"Training Programs",
  aboutustest41:"Diverse Team",
  aboutustest42:"Building",
  aboutustest43:"Annual Dinner, Spring Trip, Frisbee, Curling & Trendy Activities Explore your hidden talents outside work with abundant fun events",
  aboutustest51:"Pragmatic & Equal",
  aboutustest52:"Workplace",
  aboutustest53:"Open workspace for higher teamwork efficiency",
  aboutustest54:"Flexible working schedule with independent time management",
  introduce1:'Talent Recruitment',
  introduce2:'service mailbox',
  introduce3:'Company Address',
  introduce4:'Beijing Cimo',
  introduce5:'Chengdu Cimo',
  dlrzx:"Agent Consultation",
  xsytet1:"Agent",
  xsytet2:"Contacts",
  xsytet3:"URL",
  xsytet4:"Buy Online",
  xsytet5:"Online shopping mall",
  datasheet:"datasheet",
  prevText:"Prev",
  nextText:"Next",
  address1:"Regional"

}


// WEBPACK FOOTER //
// ./src/lang/en.js